type ProgressBarProps = {
	completed: number;
	total: number;
};

export const ProgressBar = ({ completed, total }: ProgressBarProps) => {
	const percent = total > 0 ? (completed / total) * 100 : 0;
	const position = Math.min(completed + 1, total);

	return (
		<div className="absolute -top-16 left-0 right-0">
			<div className="mb-1.5 flex items-center justify-between text-sm text-white">
				<span className="font-medium tabular-nums">
					Structure {position} of {total}
				</span>
				<span className="tabular-nums text-white/70">{percent.toFixed(0)}%</span>
			</div>
			<div className="relative h-3 w-full overflow-hidden rounded-full bg-white/25">
				<div
					className="absolute left-0 top-0 h-full rounded-full bg-primary transition-all duration-500"
					style={{ width: `${percent}%` }}
				/>
			</div>
		</div>
	);
};
